module.exports = __webpack_public_path__ + "static/mintcuddles-9889f3acbb28b7a6e1668c2f0d3f0e29.jpeg";